export const DashboardsLoadingView = () => {
  return (
    <div className="tw-animate-pulse tw-cds-p-7">
      <div className="tw-flex tw-items-center tw-cds-gap-4 tw-cds-mb-4">
        <div className="tw-h-8 tw-w-48 tw-rounded tw-cds-bg-primary tw-opacity-20" />
        <div className="tw-h-6 tw-w-16 tw-rounded-full tw-cds-bg-primary tw-opacity-20" />
      </div>
      <div className="tw-h-5 tw-w-80 tw-rounded tw-cds-bg-primary tw-opacity-20" />
    </div>
  );
};
